<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Retour sur l'offre de base prépayée</div>
</div>
<div class="col-12 mt-4">
    <div class="bold-red-text">
        <div class="bold-label-option">
            Etes-vous sûr de revenir sur l'offre de base prépayée ?
        </div>
    </div>
    <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="save()">Valider<span></span></button>
        </div>
    </div>
</div>